/**
 * Texts of the Flotte screens (list + vehicle detail), kept out of the JSX.
 * Card labels live in the cards' declarative configs (`fleetListConfig.ts`,
 * `vehicleInfoConfig.ts`).
 */

import type { FleetCounts } from './vehicleStatus';

export const FLEET_LIST_TEXT = {
  searchPlaceholder: 'Rechercher par immat, marque, modèle…',
  /** Page subtitle of the design: « 11 véhicules actifs · 1 sortis ». */
  subtitle: ({ active, out }: FleetCounts): string =>
    `${String(active)} véhicules actifs · ${String(out)} sortis`,
} as const;

/** Stable key of a vehicle detail tab (also the `Tabs` value). */
export type VehicleTabKey = 'details' | 'contrat' | 'garanties' | 'sinistres' | 'documents';

export interface VehicleTab {
  key: VehicleTabKey;
  label: string;
  /** Show the number of rows of the tab after its label (when > 0). */
  showCount?: boolean;
}

/** Tabs of the vehicle detail, in design order. */
export const VEHICLE_TABS: readonly VehicleTab[] = [
  { key: 'details', label: 'Détails' },
  { key: 'contrat', label: 'Contrat' },
  { key: 'garanties', label: 'Garanties' },
  { key: 'sinistres', label: 'Sinistres', showCount: true },
  { key: 'documents', label: 'Documents' },
];

export const VEHICLE_PAGE_TEXT = {
  /** Accessible label of the tab list. */
  tabsLabel: 'Sections du véhicule',
} as const;
